import {
  Component,
  Input
} from '@angular/core';

import { skyAnimationSlide } from '../animation/slide';

import { SkyRepeaterService } from './repeater.service';
import { SkyLogService } from '../log/log.service';
import { SkyCheckboxChange } from '../checkbox/checkbox.component';


export class SkyRepeaterItemComponent {
  public get isExpanded(): boolean {
    return this._isExpanded;
  }

  
  public set isExpanded(value: boolean) {
    this.updateForExpanded(value, true);
  }

  public get isSelected(): boolean {
    return this._isSelected;
  }

  
  public selectable: boolean = false;

  public slideDirection: string;

  public get isCollapsible(): boolean {
    return this._isCollapsible;
  }

  public set isCollapsible(value: boolean) {
    if (this._isCollapsible !== value) {
      this._isCollapsible = value;

      /*istanbul ignore else */
      if (!this._isCollapsible) {
        this.updateForExpanded(true, false);
      }
    }
  }

  private _isCollapsible = true;

  private _isExpanded = true;

  private _isSelected = false;

  constructor(
    private repeaterService: SkyRepeaterService,
    private logService: SkyLogService
  ) {
    this.slideForExpanded(false);
  }

  public headerClick() {
    if (this.isCollapsible) {
      this.updateForExpanded(!this.isExpanded, true);
    }
  }

  public chevronDirectionChange(direction: string) {
    this.updateForExpanded(direction === 'up', true);
  }

  public updateForExpanded(value: boolean, animate: boolean) {
    if (this.isCollapsible === false && value === false) {
      this.logService.warn(
        `Setting isExpanded to false when the repeater item is not collapsible
        will have no effect.`
      );
    } else if (this._isExpanded !== value) {
      this._isExpanded = value;

      this.repeaterService.onItemCollapseStateChange(this);
      this.slideForExpanded(animate);
    }
  }

  public updateIsSelected(value: SkyCheckboxChange) {
    this._isSelected = value.checked;
  }

  private slideForExpanded(animate: boolean) {
    this.slideDirection = this.isExpanded ? 'down' : 'up';
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-repeater-item',
  styles: [`.sky-repeater-item {
  display: flex;
  padding: 10px;
  border-bottom: 1px dotted #cdcfd2;
}

.sky-repeater-item-left {
  padding-top: 7px;
}

.sky-repeater-item-right {
  flex-grow: 1;
}

.sky-repeater-item-header {
  align-items: center;
  display: flex;
}

.sky-repeater-item-chevron {
  margin-left: 10px;
}

.sky-repeater-item-context-menu {
  padding: 5px 10px 0 0;
}

.sky-repeater-item-checkbox {
  padding: 0 10px 0 0;
}

.sky-repeater-item-selected {
  background-color: #f1eef6;
  transition: background-color 150ms;
}

.sky-repeater-item-title {
  font-family: "Blackbaud Sans", "Helvetica Neue", Arial, sans-serif;
  color: #282b31;
  font-weight: 600;
  font-size: 16px;
  margin: 10px 0;
  flex-grow: 1;
}

.sky-repeater-item-collapsible .sky-repeater-item-header {
  cursor: pointer;
}

.sky-repeater-item-collapsible .sky-repeater-item-content {
  padding-right: 34px;
}

.sky-repeater-item-collapsed .sky-repeater-item-content {
  display: none;
}
`],
  template: `<section
    class="sky-repeater-item"
    [ngClass]="{'sky-repeater-item-collapsible': isCollapsible, 'sky-repeater-item-selected': isSelected}"
>

  <div class="sky-repeater-item-left">
    <sky-checkbox
      *ngIf="selectable"
      class="sky-repeater-item-checkbox"
      [checked]="isSelected"
      [label]="'repeater_item_checkbox_label' | skyResources"
      (change)="updateIsSelected($event)"
    >
    </sky-checkbox>
    <div
        class="sky-repeater-item-context-menu"
        [hidden]="contextMenuEl.children.length === 0"
        #contextMenuEl
    >
      <ng-content select="sky-repeater-item-context-menu"></ng-content>
    </div>
  </div>
  <div class="sky-repeater-item-right">
    <header
        class="sky-repeater-item-header"
        [hidden]="titleEl.children.length === 0"
        (click)="headerClick()"
    >
      <h1 class="sky-repeater-item-title" #titleEl>
        <ng-content select="sky-repeater-item-title"></ng-content>
      </h1>
      <div class="sky-repeater-item-chevron" [hidden]="!isCollapsible">
        <sky-chevron
            [direction]="isExpanded ? 'up' : 'down'"
            (directionChange)="chevronDirectionChange($event)"
        >
        </sky-chevron>
      </div>
    </header>
    <div class="sky-repeater-item-content" [@skyAnimationSlide]="slideDirection">
      <ng-content select="sky-repeater-item-content"></ng-content>
    </div>
  </div>
</section>
`,
  animations: [skyAnimationSlide]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: SkyRepeaterService, },
{type: SkyLogService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'isExpanded': [{ type: Input },],
'selectable': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
